import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { Licence } from '@classes/licence/licence';
import { LicenceService } from '@services/licence.service';

@Component({
    selector: 'app-licence-summary',
    templateUrl: './licence-summary.component.html',
    styleUrls: ['./licence-summary.component.scss']
})
export class LicenceSummaryComponent implements OnInit, OnDestroy {
    @Input() licence: Licence;

    private licenceSub: Subscription;

    isEditMode: boolean;

    constructor(
        private licenceSrv: LicenceService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
    }

    onEdit(): void {
        this.isEditMode = true;
    }

    onCancelEdit(): void {
        this.isEditMode = false;
    }

    private initSubscriptions(): void {
        this.licenceSub = this.licenceSrv.selectedLicenceChanged
        .subscribe(licence => {
            this.licence = licence;

            if(this.isEditMode) {
                this.isEditMode = false;
            }
        });
    }

    ngOnDestroy() {
        if(this.licenceSub) {
            this.licenceSub.unsubscribe();
        }
    }
}
